import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Label from './Label';
import { listenForSpacebar } from '../../../../common/helpers/accessibility';

const LabelContainer = ({ id, label, showAditionalElement, addFocusHandler }) => {
	const labelClasses = cx('onboarding-box__label', {
		'onboarding-box__label--with-additional-element': showAditionalElement,
	});

	return (
		<label
			className={labelClasses}
			onFocus={() => addFocusHandler && window.addEventListener('keyup', listenForSpacebar)}
			onBlur={() => addFocusHandler && window.removeEventListener('keyup', listenForSpacebar)}
			htmlFor={id}
		>
			{showAditionalElement ? (
				<div>
					<Label label={label} />
				</div>
			) : (
				<Label label={label} />
			)}

			{showAditionalElement && (
				<span className="onboarding-box__additional-element">{showAditionalElement}</span>
			)}
		</label>
	);
};

LabelContainer.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	showAditionalElement: PropTypes.node,
	addFocusHandler: PropTypes.bool,
};

LabelContainer.defaultProps = {
	showAditionalElement: null,
	addFocusHandler: false,
};

export default LabelContainer;
